var login={
	el:$(".m-loginPop"),
	init:function(){
		// var cssFile = getAbsoluteUrl(require('!file!autoprefixer?{browsers: "> 1%"}!less!../css/login.css'));
		// var urs = new URS({
        //     newCDN: 1,
        //     version: 3,
        //     product : 'd21', //【必须】使用的产品ID，如urs
        //     promark : 'dNvgFOK', //【必须】【申请】申请的组件ID，被分派ID
        //     host : 'hd.tianyu.163.com',
        //     productKey: '1bc7680eee080ce2026757eca30d0e53',
        //     includeBox: 'login',
        //     needanimation: 0,
        //     cssDomain: cssFile.replace(/[^\/]+?$/, '').replace('http://','https://'),
        //     cssFiles: cssFile.match(/([^\/]+?)$/)[1],
        //     placeholder : { account: '网易通行证' },
        //     needRegAgreeNoChecked: 1,
        //     needRegAgreeMbNoChecked: 1,
        //     needClause: 1,
        //     clause: 0
        // });

        // urs.logincb = urs.regcb = function (urs) {
        //     window.location.reload();
        // };

        nie.define('login', function() {
            var Login = nie.require('nie.util.login2');
            window.Login = Login
            var example = Login.create({
                holder: '#login',
                success: function (params) {
                    window.location.reload();
                }
            });
        })

        var self=this;
        this.el.find(".closeBtn").click(function(){
            self.close();
        })

        $(".logoutBtn").attr("href","http://reg.163.com/Logout.jsp?username="+urs+"&url=" + window.location.href);
	    $(".loginBtn").click(function(){
            self.show();
        })
    },
    close:function(){
        this.el.fadeOut();
    },
    show:function(){
        this.el.fadeIn();
    }
}

function getAbsoluteUrl (url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}

module.exports = login;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/login.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6